<template>
    <AlertDialog :open="isOpen" @update:open="handleOpenChange">
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ title }}</AlertDialogTitle>
            </AlertDialogHeader>

            <div class="mb-4">
                <slot>Are you sure?</slot>
            </div>

            <div class="flex justify-end space-x-2">
                <AlertDialogCancel @click="onConfirm(false)"> No </AlertDialogCancel>
                <AlertDialogAction @click="onConfirm(true)"> Yes </AlertDialogAction>
            </div>
        </AlertDialogContent>
    </AlertDialog>
</template>

<script setup>
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogAction,
    AlertDialogCancel
} from '@/components/ui/alert-dialog';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: 'Confirm'
    }
});

const emit = defineEmits(['update:isOpen', 'confirm']);

// If the modal is closed via the X button or outside click, treat it as a cancellation.
const handleOpenChange = (open) => {
    if (!open) {
        emit('update:isOpen', false);
        emit('confirm', null); // null indicates cancellation
    }
};

const onConfirm = (choice) => {
    emit('confirm', choice);
    emit('update:isOpen', false);
};
</script>
